<div class="modal-content modal-content-right">
  <div class="modal-header">
    <h5 class="modal-title"> Import {{importTypeHeader}}</h5>
    <button type="button" class="close" (click)="close()" aria-label="Close">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>

  <div class="modal-body">
    <div class="row">
        <div class="col-md-12">
          <label>
            Confirm each record from your imported file.
          </label>
          <ag-grid-angular
            style="width: 100%"
            class="ag-theme-material"
            [rowData]="itemsDataSource"
            [getRowStyle]="gridRowStyle"
            (gridReady)="onGridReady($event)"
            [pagination]="true"
            [paginationPageSize]="10"
            [columnDefs]="columns">
          </ag-grid-angular>
        </div>
      </div>
    <div class="row">
        <div class="col-md-12 text-right">
         <small><i class="fas fa-stop text-danger"></i> - Duplicate </small>
        </div>
      <div class="col-md-12 text-right">
         <small><i class="fas fa-stop text-warning"></i> -  Missing required field(s). Will not be imported. </small>
        </div>
      </div>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-outline" (click)="upload()" [disabled]="busy">
      <i class="fas fa-upload"></i> Upload
    </button>

  </div>
</div>
